import { render, staticRenderFns } from "./OvertimeDetails.vue?vue&type=template&id=6e8be314&"
import script from "./OvertimeDetails.vue?vue&type=script&lang=js&"
export * from "./OvertimeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports